export default "__VITE_ASSET__92f1ee05__"